import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  standardText: {
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    color: '#ffffff',
  },
  h2Tag: {
    marginBottom: '0px',
    marginTop: '0px',
    fontSize: '35px',
    color: '#ff8c00 !important',
    [theme.fn.smallerThan(520)]: {
      fontSize: '37px',
    },
    [theme.fn.smallerThan(500)]: {
      fontSize: '36.5px',
    },
    [theme.fn.smallerThan(480)]: {
      fontSize: '35px',
    },
    [theme.fn.smallerThan(450)]: {
      fontSize: '33px',
    },
    [theme.fn.smallerThan(440)]: {
      fontSize: '32px',
    },
    [theme.fn.smallerThan(390)]: {
      fontSize: '28px',
    },
    [theme.fn.smallerThan(331)]: {
      fontSize: '25px',
    },
  },
  aHref: {
    color: '#b476eeff',
    '&:hover': {
      opacity: 0.75,
    },
  },
  spanPre: {
    whiteSpace: 'pre',
  },
  pJoinThousands: {
    marginTop: '0px',
    fontSize: '20px',
  },
  asianTextBlock: {
    whiteSpace: 'nowrap',
  },
}))
